module.exports = __webpack_public_path__ + "static/media/good-order-v3.0d7ed265.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/good-order-v3.jpg
// module id = 30
// module chunks = 0